import {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import {ErrorMessage} from '@hookform/error-message';
import {useForm, Controller} from 'react-hook-form';
import FormInput from '../../components/FoodMenu/FormInput';

import {
    updateTakeawaySettings,
    getTakeawaySettings,
} from '../../../services/SettingsService';
import TimePicker from '../../components/Settings/TimePicker';
import {objectToFormData} from '../../../utils/objectToFormData';
const notify = (id, type, message, time) => {
    toast.update(id, {
        render: message,
        type: type,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        isLoading: false,
    });
};
const TakeawaySettings = () => {
    const [takeawaydetails, setTakeawaydetails] = useState();
    const {
        handleSubmit,
        formState: {errors},
        register,
        setValue,
        control,
    } = useForm({
        mode: 'all',
        defaultValues: {
            slot_start_time:
                new Date('2000-01-01 10:00 AM').getHours() +
                ':' +
                String(new Date('2000-01-01 10:00 AM').getMinutes()).padStart(
                    2,
                    '0'
                ),
            slot_end_time:
                new Date('2000-01-01 11:00 PM').getHours() +
                ':' +
                String(new Date('2000-01-01 11:00 PM').getMinutes()).padStart(
                    2,
                    '0'
                ),
        },
    });
    useEffect(() => {
        getTakeawaySettings().then(res => {
            setTakeawaydetails(res);
        });
    }, []);

    const days = [
        {
            name: 'takeaway_days.sun',
            label: 'Sunday',
        },
        {
            name: 'takeaway_days.mon',
            label: 'Monday',
        },
        {
            name: 'takeaway_days.tue',
            label: 'Tuesday',
        },
        {
            name: 'takeaway_days.wed',
            label: 'wednesday',
        },
        {
            name: 'takeaway_days.thu',
            label: 'Thursday',
        },
        {
            name: 'takeaway_days.fri',
            label: 'Friday',
        },
        {
            name: 'takeaway_days.sat',
            label: 'Saturday',
        },
    ];

    useEffect(() => {
        if (takeawaydetails) {
            const fields = [
                'slot_duration',
                'takeaway_prior_time',
                'takeaway_booking_charge',
                'takeaway_days',
                'slot_start_time',
                'slot_end_time',
            ];

            fields.forEach(field => setValue(field, takeawaydetails[field]));
        }
    }, [setValue, takeawaydetails]);

    const onSubmit = async data => {
        const toaster = toast.loading('Updating...');

        let postData = objectToFormData(data);
        let res = await updateTakeawaySettings(postData);
        if (res.status === 'success') {
            notify(toaster, 'success', 'Updated Takeaway Settings!', 2000);
        } else {
            notify(toaster, 'error', res.data.message, 2000);
        }
    };

    return (
        <>
            <div className='modal-body'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='d-flex row'>
                        <div className='col-md-6 col-xl-3 col-xxl-6 mb-3 picker-data'>
                            <div className='color-time-picker'>
                                <TimePicker
                                    label={'Start time'}
                                    name={'slot_start_time'}
                                    required={true}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    id={'slot_start_time'}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('slot_start_time'),
                                        required:
                                            'Slot Start time is required!',
                                    }}
                                />
                            </div>
                        </div>
                        <div className='col-md-6 col-xl-3 col-xxl-6 mb-3 picker-data'>
                            <div className='color-time-picker '>
                                <TimePicker
                                    label={'End time'}
                                    name={'slot_end_time'}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    id={'slot_end_time'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('slot_end_time'),
                                        required: 'Slot End time is required!',
                                    }}
                                />
                            </div>
                        </div>

                        <div className='col-10'>
                            <FormInput
                                label={'Takeaway Prior time (minutes)'}
                                id={'takeaway_prior_time'}
                                name={'takeaway_prior_timee'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('takeaway_prior_time', {
                                        required:
                                            'Takeaway Prior time is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className='col-10'>
                            <FormInput
                                label={'Slot Length (minutes)'}
                                id={'slot_duration'}
                                name={'slot_duration'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('slot_duration', {
                                        required: 'Slot length is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className='col-10'>
                            <FormInput
                                label={'Take away Charge'}
                                id={'takeaway_booking_charge'}
                                name={'takeaway_booking_charge'}
                                required={true}
                                type={'number'}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('takeaway_booking_charge', {
                                        required:
                                            'Takeaway charge is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>

                        <label className='text-black font-w500 col-12'>
                            Delivery days
                        </label>
                        {days.map((day, i) => (
                            <div className='col-4 '>
                                <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                    <input
                                        type='checkbox'
                                        defaultChecked
                                        className='custom-control-input'
                                        {...register(day.name)}
                                        id={day.name}
                                    />
                                    <label
                                        className='custom-control-label'
                                        htmlFor={day.name}
                                    >
                                        {day.label}
                                    </label>
                                </div>
                            </div>
                        ))}

                        {/* <div className='col-12'>
                            <div className='custom-control custom-checkbox mb-3 '>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_free_delivery')}
                                    id='is_free_delivery'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='is_free_delivery'
                                >
                                    Free Delivery
                                </label>
                            </div>
                        </div> */}
                        <button className='btn btn-primary btn-block btn-md mb-2 mr-auto'>
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};
export default TakeawaySettings;
